<template>
  <div id="app">
    <MarketingHeader template="jet" />
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  computed: {
    buttonAction() {
      return this.authState.isAuthenticated ? this.logout() : this.login();
    },
    buttonText() {
      return this.authState.isAuthenticated ? "Logout" : "Login";
    },
  },
  methods: {
    login() {
      this.$auth.signInWithRedirect();
    },
    async logout() {
      await this.$auth.signOut();
    },
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;600;900&display=swap");
body {
  padding: 0;
  margin: 0;
}

#app {
  --colour-white-1: rgb(255, 255, 255);
  --colour-orange-1: rgb(255, 128, 0);
  --colour-orange-2: rgb(255, 172, 89);
  --colour-orange-3: rgb(255, 217, 178);
  --colour-orange-4: rgb(255, 234, 212);
  --colour-orange-5: rgb(255, 234, 212);
  --colour-orange-6: rgb(248, 245, 242);
  --colour-teal-1: rgb(10, 56, 71);
  --colour-blue-1: rgb(21, 114, 245);
  --colour-green-1: rgb(36, 206, 48);
  --colour-grey-1: rgb(34, 34, 34);
  --colour-grey-2: rgb(76, 76, 76);
  --colour-grey-3: rgb(135, 135, 135);
  --colour-grey-4: rgb(118, 118, 118);
  --colour-grey-5: rgb(215, 215, 215);

  margin: 40px 0 0 0;
  padding: 0;

  font-family: "Inter", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--colour-orange-1);
}
.logo {
  width: 400px !important;
}
</style>
